module.exports = __webpack_public_path__ + "static/img/newimg2.4186ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg2.png
// module id = Vx/N
// module chunks = 1